import * as React from 'react';
import { connect } from 'react-redux';

import AddCatalogPageComponent from './AddCatalogPageComponent';
import { onAddSinglePageOrSpread, onAddMultiPageOrSpread, onAddAgronomySpread, onAddMixedSpread, onPageOrSpreadSelect, onRemovePage, onRemoveSpread, moveThumbnail } from '../../../../actions/actions';
import { IBranding, IDisclaimer, IDocument, IDragInfo, IEditorState, IPage, IPlaceHolder, ISpread } from '../../../../infrastructure/interfaces';
import { PageType } from '../../../../infrastructure/PageType';
import { productType } from '../../../../infrastructure/ProductType';

import { IWizardState } from '../../../Wizard/Wizard';
import ResultPage from '../CropPageView/common/PageResult';
import Logo from '../SidePanel/Logo';
import DragThumbnail from './DragThumbnail';
import {stringIdentifierForLayoutType} from '../../../../infrastructure/LayoutTypes';
import CatalogContainer from '../CropPageView/Catalog/CatalogContainer';
import BulletinContainer from '../CropPageView/Bulletin/BulletinContainer';
import PagesTab from '../SidePanel/PagesTab/PagesTab';

export interface IResultAsideProps {
  pages?: IPage[];
  spreads?: ISpread[];
  isSpreadView: boolean;
  selectedPage?: IPage;
  selectedSpread?: ISpread;
  onPageSelect?(page: IPage, e: any | undefined): void;
  onSpreadSelect?(spread: ISpread, e: any| undefined): void;
  onAddSinglePageOrSpread?(): void;
  onAddMultiPageOrSpread?(): void;
  onAddAgronomySpread?(): void;
  onAddMixedSpread?(): void;
  onRemovePage?(pageId: number): void;
  onRemoveSpread?(spreadId: number): void;
  document: IDocument | null;
  brandings?: IBranding[];
  disclaimers: IDisclaimer[] | null;
  editor?: IEditorState;
  router?: any;
  wizard?: IWizardState;
  dividers?: any;
  moveThumbnail?(dragIndex: number, hoverIndex: number): void;
  isEditorView: boolean;
}
const mapDispatchToProps = (dispatch: any): any => {
  return {
    onSpreadSelect: (spread: ISpread, e: any): void => {
      if ((e == null) || (e.target.getAttribute('data-name') !== 'remove-page')) {
        dispatch(onPageOrSpreadSelect(spread));
      }
    },
    onPageSelect: (page: IPage, e: any): void => {
      if ((e == null) || (e.target.getAttribute('data-name') !== 'remove-page')) {
        dispatch(onPageOrSpreadSelect(page));
      }
    },
    onAddSinglePageOrSpread: (): void => {
      dispatch(onAddSinglePageOrSpread());
    },
    onAddMultiPageOrSpread: (): void => {
      dispatch(onAddMultiPageOrSpread());
    },
    onAddAgronomySpread: (): void => {
      dispatch(onAddAgronomySpread());
    },
    onAddMixedSpread: (): void => {
      dispatch(onAddMixedSpread());
    },
    onRemovePage: (pageId: any): void => {
      dispatch(onRemovePage(pageId));
    },
    onRemoveSpread: (spreadId: any): void => {
      dispatch(onRemoveSpread(spreadId));
    },
    moveThumbnail: (dragIndex: number, hoverIndex: number) => {
      dispatch(moveThumbnail(dragIndex, hoverIndex));
    },
  };
};

const mapStateToProps = (state: any): any => {
  return {
    pages: state.document.pages,
    spreads: state.document.spreads,
    type: state.document.type,
    document: state.document,
    brandings: state.wizard.brandings,
    disclaimers: state.wizard.disclaimers,
    userData: state.user.data,
    editor: state.editor,
    router: state.router,
    dividers: state.wizard.dividers,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ResultAside extends React.Component<IResultAsideProps> {
  constructor(props: IResultAsideProps) {
    super(props);
  }

  renderPage(page: IPage) {
    let layout: string = stringIdentifierForLayoutType(page.layout);

    return (page.placeholders.map((m, i) => {
      const index = i;
      return (
        <ResultPage
          pagePosition={page.position}
          lastDroppedItem={m}
          index={index}
          key={i}
          document={this.props.document}
          pageNumber={page.number}
          isAside={true}
          layout={layout}
        />);
    }));
  }

  onAddSinglePageOrSpread = () => {
    if (this.props.onAddSinglePageOrSpread != undefined) {
      this.props.onAddSinglePageOrSpread();
    }
  }
  onAddMultiPageOrSpread = () => {
    if (this.props.onAddMultiPageOrSpread != undefined) {
      this.props.onAddMultiPageOrSpread();
    }
  }
  onAddAgronomySpread = () => {
    if (this.props.onAddAgronomySpread != undefined) {
      this.props.onAddAgronomySpread();
    }
  }
  onAddMixedSpread = () => {
    if (this.props.onAddMixedSpread != undefined) {
      this.props.onAddMixedSpread();
    }
  }
  onRemovePage = (e: any) => {
    if (this.props.onRemovePage != undefined) {
      const pageId = e.target.parentNode.parentNode.getAttribute('data-id');
      this.props.onRemovePage(Number(pageId));
    }
  }
  onRemoveSpread = (e: any) => {
    if (this.props.onRemoveSpread != undefined) {
      const spreadId = e.target.parentNode.parentNode.getAttribute('data-id');
      this.props.onRemoveSpread(Number(spreadId));
    }
  }

  renderSpreads = (spreads: ISpread[], selected: ISpread, docType: any) => {
    const environment = this.props.router.location.pathname;
    return spreads.map((spread, i) => {

      if (this.props.document == null) {
        return (<div></div>);
      }
      const selectedSpread = spread.left.number === selected.left.number;
      // Don't have remove button on cover page
      const removeButtonMarkup = ((spread.right == null) || (spread.right.number > 2))
      ? (
        <button
            className={`btn-remove-page ${environment.substring(1, environment.length)}`}
            data-name="remove-page"
            onClick={this.onRemoveSpread}
          >
            <span className="remove"></span>
          </button>
      )
      : (<div></div>);
      const markup = (
        <div
          className={`crop-page-box ${selectedSpread ? 'is-active' : ''}`}
          key={i}
          data-id={spread.id}
          onClick={e => this.props.onSpreadSelect!(spread, e)}
        >
          <CatalogContainer
            spreadToRender={spread}
            handleDrop={(index: number, data: IPlaceHolder, dragInfo: IDragInfo) => {}}
            removeProduct={(data: any, index: number) => {}}
            moveCrop={(dragIndex: number, hoverIndex: number) => {}}
            isSpreadView={this.props.isSpreadView}
            disclaimers={[]}
            document={this.props.document ? this.props.document : null}
            isEditorRendering={false}
          />
          {removeButtonMarkup}
        </div>
      );
      const canDrag = (spread.left.type == PageType.Page) && this.props.isEditorView;
      return <DragThumbnail
          canDrag={canDrag}
          index={i}
          moveThumbnail={this.props.moveThumbnail}
          key={i}
          type={-1}
          position={""}
          item={markup}
          isOver={false}
          canDrop={false}
          isDragging={false} />;
    });
  }

  renderPages = (pages: IPage[], selected: IPage, docType: any) => {
    if (this.props.document == null) {
      return (<div></div>);
    }

    return pages.map((page, i) => {
      const selectedPage = page.number === selected.number;

      switch (this.props.document!.type) {
        case productType.Catalog:
          {
            const markup = (
              <div
                className={`crop-page-box isSingle ${page.position} ${selectedPage ? 'is-active' : ''}`}
                key={i}
                data-id={page.number}
                onClick={e => this.props.onPageSelect!(page, e)}
              >
                <CatalogContainer
                  pageToRender={page}
                  handleDrop={(index: number, data: IPlaceHolder, dragInfo: IDragInfo) => {}}
                  removeProduct={(data: any, index: number) => {}}
                  moveCrop={(dragIndex: number, hoverIndex: number) => {}}
                  document={this.props.document ? this.props.document : null}
                  isSpreadView={this.props.isSpreadView}
                  disclaimers={[]}
                  isEditorRendering={false}
                />
              </div>
            );
            const canDrag = page.type === PageType.Page;
            return this.props.isEditorView ?
              <DragThumbnail
                canDrag={canDrag}
                index={i}
                moveThumbnail={this.props.moveThumbnail}
                key={i}
                type={page.placeholders[0].type}
                position={page.position}
                item={markup}
                isOver={false}
                canDrop={false}
                isDragging={false} /> :
              markup;
          }
        case productType.Bulletin:
          {
            return (
              <div
                className={`crop-page-box ${page.position} ${selectedPage ? 'is-active' : ''}`}
                key={i}
                data-id={page.number}
                onClick={e => this.props.onPageSelect!(page, e)}
              >
                <BulletinContainer
                  handleDrop={(index: number, data: IPlaceHolder, dragInfo: IDragInfo) => {}}
                  removeProduct={(data: any, index: number) => {}}
                  moveCrop={(dragIndex: number, hoverIndex: number) => {}}
                  document={this.props.document ? this.props.document : null}
                  disclaimers={this.props.wizard!.disclaimers}
                  page={this.props.editor!.selectedPage!}
                  isEditorRendering={false}
                />
              </div>
            );
          }
        default:
          return (
            <div></div>
          );
      }
    });
  }

  onSpreadSelect = (spread: ISpread) => {
  if((this.props.document != null)
     && (this.props.onSpreadSelect != undefined)) {
      this.props.onSpreadSelect(spread, undefined);
      this.setState({ selectedSpread: spread, selectedPage: (spread.right != null) ? spread.right : spread.left });
    }
  }

  onPageSelect = (page: IPage) => {
    if((this.props.document != null)
     && (this.props.onPageSelect != undefined)) {
      const selectedSpread = this.props.document.spreads
        .find(s => s.left.number === page.number || ((s.right != null) && (s.right.number === page.number)));
      this.props.onPageSelect(page, undefined);
      this.setState({ selectedSpread, selectedPage: page });
    }
  }

  buildPagesTab = () => {
    
    if ((this.props.editor == null) || (this.props.document == null)) {
      return <div></div>
    }
    const tabs = (
      <PagesTab
            selectedSpread={this.props.editor.selectedSpread!}
            selectedPage={this.props.editor.selectedPage!}
            pages={this.props.document.pages}
            spreads={this.props.document.spreads}
            selectPage={this.onPageSelect}
            selectSpread={this.onSpreadSelect}
            productType={this.props.document.type}
      />);
          
    return tabs;
  }

  renderPlaceholders(selectedPage: IPage, selectedSpread: ISpread) {

    if ((this.props.spreads == null) || (this.props.document == null)) {
      return(<div></div>);
    }

    if ((this.props.document.type === productType.Brochure)
        || (this.props.document.type === productType.Postcard)) {
      return (
        this.buildPagesTab()
      )
    }

    if (this.props.isSpreadView) {
      return this.renderSpreads(this.props.spreads, selectedSpread, this.props.document.type);
    }
    return this.renderPages(this.props.pages!, selectedPage, this.props.document.type);
  }

  render() {

    const placeholderPage: IPage = {
      title: "",
      type: PageType.Page,
      number: 0,
      position: "",
      placeholders: []
    };
    const placeholderSpread: ISpread = {
      left: placeholderPage,
      right: placeholderPage,
      id: 0,
    }
    const isSpreadView = (this.props.isSpreadView) && (this.props.document!.type === 'Catalog');
    const position = (this.props.editor && this.props.editor.selectedPage) ? this.props.editor.selectedPage : '';
    const selectedSpread = (this.props.editor && this.props.editor.selectedSpread) ? this.props.editor.selectedSpread : placeholderSpread;
    const classNameBox = isSpreadView ? '' : `isSingle ${position}`;
    const selectedPage = (this.props.editor && this.props.editor.selectedPage) ? this.props.editor.selectedPage : placeholderPage;

    return (
      <div className={`sidePane sidePane--white ${classNameBox} ${this.props.document!.type}`}>
        <div className="result-aside">
          {this.renderPlaceholders(selectedPage, selectedSpread)}
        </div>
        {this.props.document!.type === 'Catalog'
          ? <AddCatalogPageComponent />
          : null}
        <Logo />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Result/ResultAside.tsx